import { render, staticRenderFns } from "./UnsupportedBrowser.vue?vue&type=template&id=5949f055"
import script from "./UnsupportedBrowser.vue?vue&type=script&lang=ts"
export * from "./UnsupportedBrowser.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports